import {
  Avatar,
  Button,
  Card,
  CardActionArea,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Hidden,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Snackbar,
  Switch,
  Typography,
} from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowBack, ArrowForward, ArrowForwardIos, Inbox, Language, Notifications, SmsFailedOutlined } from "@material-ui/icons";
import { Alert, Skeleton } from "@material-ui/lab";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { withFirebase } from "../Firebase";
import { AuthUserContext, withAuthorization } from "../Session";
import { BirthDayEdit, DNIEdit, EnableComunicationsEdit, LangsEdit, NameEdit, PhoneNumberEdit } from "./UserItemsEdit";
import * as ROUTES from "../../constants/routes";

const UserProfile = (props) => {
  const { firebase, uid } = props;
  const history = useHistory();
  const { t } = useTranslation();

  const [userData, setUserData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const userREf = firebase.user(uid);
    const onValueChange = (snap) => {
      const USERPROFILE = snap.val();
      setUserData({
        info: { userFullName: `${USERPROFILE.info.name} ${USERPROFILE.info.surname} ${USERPROFILE.info.secondSurname}`, ...USERPROFILE.info },
        sgpfc: { ...USERPROFILE.sgpfc },
      });
      setIsLoading(false);
    };
    userREf.on("value", onValueChange);

    return () => {
      userREf.off("value", onValueChange);
    };
  }, []);

  const classes = useStyles();
  const infoSection = {
    title: "mi_cuenta_reanibex",
    description:
      "Información_personal_y_opciones_para_gestionarla._Puedes_revisar_el_estado_de_tu_perfil_como_voluntario_y_cambiar_la_información_de_contacto_para_que_podamos_informarte_de_nuevos_eventos,_noticias_o_actualizaciones",
    image: "profile_info",
    cards: [
      {
        title: "datos_personales",
        size: 12,
        list: false,
        items: [
          { admin: false, item: "name", value: ["info", "userFullName"], type: "name", editable: true },
          { admin: false, item: "birthDay", value: ["info", "birthday"], type: "date", editable: true },
          { admin: false, item: "dni", value: ["info", "dni"], type: "dni", editable: true },
          //  {admin:false, item: "Fecha de creación", value: "5 Enero 2021", editable: false },
        ],
      },
      {
        title: "datos_de_contacto",
        size: 12,
        list: false,
        items: [
          { admin: false, item: "phone", value: ["info", "phone"], type: "phone", editable: true },
          { admin: false, item: "email", value: ["info", "email"], editable: false },
          { admin: false, item: "comunicaciones_comerciales", value: ["info", "comunicaciones"], trasnlate: true, isBoolean: true, type: "businessCom", editable: true },
          { item: "contactLang", value: ["info", "comunicationsLang"], type: "lang", param: "comunicationsLang", editable: true, admin: true },
        ],
      },
    ],
  };

  const SettingsSection = {
    title: "preferencias_de_la_cuenta_Reanibex",
    description: "formas_de_verificar_que_eres_tú_y_ajustes_del_peril",
    image: "settingsProfile",
    cards: [
      {
        title: "password",
        description: "si_eliges_una_contraseña_segura,_ayudas_a_proteger_tu_cuenta_Reanibex",
        size: 6,
        list: true,
        items: [{ admin: false, item: "········", value: ["sgpfc", "lastPasswordChange"], type: "password", param: "lastPasswordChange", editable: true }],
      },
      {
        title: "preferencias_generales",
        description: "gestiona_la_configuración_de_idioma_en_las_plataformas",
        size: 6,
        list: true,
        items: [
          { admin: false, item: "system_Lang", value: ["info", "defaultLang"], editable: true, type: "lang", param: "defaultLang", icon: <Language /> },
          // { item: "Idioma de alertas", value: ["sgpfc", "alertLang"], editable: true, type: "lang", param: "alertLang", icon: <Notifications /> },
        ],
      },
    ],
  };

  return (
    <Grid container justifyContent="center" style={{ padding: 16 }}>
      <Grid container item xs={12} lg={7}>
        <Grid container className={classes.sectionTitleContainer}>
          <Grid item container xs={12} lg={7} alignItems="center">
            <Grid item xs={10} lg={12}>
              <Typography component="h2" className={classes.title}>
                {t(infoSection.title)}
              </Typography>
            </Grid>
            <Hidden mdUp>
              <Grid item xs={2} container alignItems="center">
                <img style={{ width: "100%" }} src={require(`../../assets/${infoSection.image}_min.png`)} />
              </Grid>
            </Hidden>

            <Typography color="textSecondary" className={classes.description} variant="h6">
              {t(infoSection.description)}
            </Typography>
          </Grid>
          <Hidden lgDown>
            <Grid item xs={5}>
              <img style={{ width: "100%" }} src={require(`../../assets/${infoSection.image}.png`)} />
            </Grid>
          </Hidden>
        </Grid>

        <Grid container spacing={3}>
          {infoSection.cards.map((k, i) => (
            <Grid item xs={12} md={k.size}>
              <InfoCard title={k.title} items={k.items} list={k.list} description={k.description} firebase={firebase} data={userData} isLoading={isLoading} />
            </Grid>
          ))}

          <CourseAndRescuerStateCard firebase={firebase} userData={userData} />
        </Grid>
      </Grid>

      <Grid container item xs={12} lg={7}>
        <Grid container className={classes.sectionTitleContainer}>
          <Grid item container xs={12} lg={7} alignItems="center">
            <Grid item xs={10} lg={12}>
              <Typography component="h2" className={classes.title}>
                {t(SettingsSection.title)}
              </Typography>
            </Grid>
            <Hidden mdUp>
              <Grid item xs={2} container alignItems="center">
                <img style={{ width: "100%" }} src={require(`../../assets/${SettingsSection.image}_min.png`)} />
              </Grid>
            </Hidden>

            <Typography color="textSecondary" className={classes.description} variant="h6">
              {t(SettingsSection.description)}
            </Typography>
          </Grid>
          <Hidden lgDown>
            <Grid item xs={5}>
              <img style={{ width: "100%" }} src={require(`../../assets/${SettingsSection.image}.png`)} />
            </Grid>
          </Hidden>
        </Grid>

        <Grid container spacing={3}>
          {SettingsSection.cards.map((k, i) => (
            <Grid item xs={12} md={k.size}>
              <InfoCard title={k.title} items={k.items} list={k.list} description={k.description} firebase={firebase} data={userData} isLoading={isLoading} />
            </Grid>
          ))}
          <Grid item xs={12} style={{ marginBottom: 16 }}>
            <Card className={classes.card} variant="outlined">
              <Grid container>
                <Grid container item xs={12}>
                  <Grid item xs={12} className={classes.CardTitleContainer}>
                    <Typography variant="h4" className={classes.CardTitle}>
                      {t("¿necesitas_ayuda?")}
                    </Typography>
                    <Typography variant="body1" color="textSecondary" className={classes.cardDescription}></Typography>
                  </Grid>
                </Grid>

                <Grid container>
                  <List style={{ width: "100%", padding: 0 }}>
                    <ListItem button style={{ paddingBottom: 24 }} onClick={() => history.push(ROUTES.SENDREPORT)}>
                      <ListItemIcon>
                        <SmsFailedOutlined />
                      </ListItemIcon>
                      <ListItemText primary={t("contacta_con_nosotros")} secondary={""} />
                      <ListItemSecondaryAction>
                        <ArrowForwardIos />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const InfoCard = (props) => {
  const classes = useStyles();
  const { title, items, list, description, isLoading, data, firebase } = props;
  const { t } = useTranslation();

  return (
    <Card className={classes.card} variant="outlined">
      <Grid container>
        <Grid container item xs={12}>
          <Grid item xs={12} className={classes.CardTitleContainer}>
            <Typography variant="h4" className={classes.CardTitle}>
              {t(title)}
            </Typography>
            <Typography variant="body1" color="textSecondary" className={classes.cardDescription}>
              {t(description)}
            </Typography>
          </Grid>
        </Grid>

        <AuthUserContext.Consumer>
          {(authUser) => (
            <Grid container>
              {!list
                ? items.map((k, i) => {
                    if ((k.admin && authUser.sgpfc.rol == "admin") || !k.admin) {
                      return (
                        <>
                          <InfoItem setUp={k} data={data} isLoading={isLoading} />
                          {i !== items.length - 1 && (
                            <Grid item xs={12}>
                              <Divider orientation="horizontal" />
                            </Grid>
                          )}
                        </>
                      );
                    }
                  })
                : items.map((k, i) => (
                    <Grid item xs={12} container>
                      <List style={{ width: "100%", padding: 0 }}>
                        <ListInfoItem setUp={k} data={data} icon={k.icon} firebase={firebase} />
                      </List>
                    </Grid>
                  ))}
            </Grid>
          )}
        </AuthUserContext.Consumer>
      </Grid>
    </Card>
  );
};

const CourseAndRescuerStateCard = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { userData, firebase } = props;

  const [report, setReport] = useState({});
  const [adminEnabledAlerts, setAdminEnabledAlerts] = useState(false);

  useEffect(() => {
    if (!!userData?.sgpfc?.reportId) {
      firebase
        .userReport(userData?.sgpfc?.reportId)
        .child("tests")
        .once("value")
        .then((snap) => {
          const reportData = snap.val();
          setReport(reportData);
        });
      setAdminEnabledAlerts(userData?.sgpfc?.notifications?.adminEnabled);
    }
  }, [userData]);

  const changeAdminNotification = () => {
    firebase.user(userData?.sgpfc?.reportId).child("sgpfc/notifications").update({ adminEnabled: !adminEnabledAlerts });
  };

  return (
    <>
      <Grid item xs={12} md={6}>
        <Card className={classes.card} variant="outlined">
          <Grid container>
            <Grid container item xs={12}>
              <Grid item xs={12} className={classes.CardTitleContainer}>
                <Typography variant="h4" className={classes.CardTitle}>
                  {t("módulos_de_entrenamiento")}
                </Typography>
                <Typography variant="body1" color="textSecondary" className={classes.cardDescription}>
                  {t("revisa_el_estado_de_los_modulos._completa_todos_para_ayudar_a_la_comunidad")}
                </Typography>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} container>
                <List style={{ width: "100%", padding: 0 }}>
                  <ListItem button style={{ paddingBottom: 24 }} className={classes.noEditableItem}>
                    <ListItemIcon>
                      <Avatar>
                        <img style={{ width: "100%" }} src={t("formation1Image")} />
                      </Avatar>
                    </ListItemIcon>
                    <ListItemText primary={t("formation1Name")} secondary={report?.ECS1?.metadata?.evalApproved ? t("completed!") : t("Pendiente_de_completar")} />
                  </ListItem>
                  <ListItem button style={{ paddingBottom: 24 }} className={classes.noEditableItem}>
                    <ListItemIcon>
                      <Avatar>
                        <img style={{ width: "100%" }} src={t("formation2Image")} />
                      </Avatar>
                    </ListItemIcon>
                    <ListItemText primary={t("formation2Name")} secondary={report?.ECS2?.metadata?.evalApproved ? t("completed!") : t("Pendiente_de_completar")} />
                  </ListItem>
                  <ListItem button style={{ paddingBottom: 24 }} className={classes.noEditableItem}>
                    <ListItemIcon>
                      <Avatar>
                        <img style={{ width: "100%" }} src={t("formation3Image")} />
                      </Avatar>
                    </ListItemIcon>
                    <ListItemText primary={t("formation3Name")} secondary={report?.ECS3?.metadata?.evalApproved ? t("completed!") : t("Pendiente_de_completar")} />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card className={classes.card} variant="outlined">
          <Grid container>
            <Grid container item xs={12}>
              <Grid item xs={12} className={classes.CardTitleContainer}>
                <Typography variant="h4" className={classes.CardTitle}>
                  {t("estado_del_voluntario")}
                </Typography>
                <Typography variant="body1" color="textSecondary" className={classes.cardDescription}>
                  {t("comprueba_de_un_vistazo_el_estado_general_de_tu_voluntariado")}
                </Typography>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} container>
                <AuthUserContext.Consumer>
                  {(authUser) => (
                    <List style={{ width: "100%", padding: 0 }}>
                      <ListItem button style={{ paddingBottom: 24 }} className={classes.noEditableItem}>
                        <ListItemText primary={t("voluntario_activo")} secondary={t("active_rescuer_" + userData?.sgpfc?.notifications?.rescuer)} />
                      </ListItem>
                      <ListItem button style={{ paddingBottom: 24 }} className={classes.noEditableItem}>
                        <ListItemText primary={t("alertas_activas")} secondary={t("alert_enabled_" + userData?.sgpfc?.notifications?.userEnabled)} />
                      </ListItem>
                      {authUser.sgpfc.rol === "admin" && (
                        <>
                          <ListItem button style={{ paddingBottom: 24 }} className={classes.noEditableItem}>
                            <ListItemText primary={t("Habilitadas por el admin")} secondary={t(userData?.sgpfc?.notifications?.adminEnabled)} />
                            <ListItemSecondaryAction>
                              <Switch checked={adminEnabledAlerts} onChange={changeAdminNotification} />
                            </ListItemSecondaryAction>
                          </ListItem>
                          <ListItem button style={{ paddingBottom: 24 }} className={classes.noEditableItem}>
                            <ListItemText primary={t("SO_de_su_movil")} secondary={t(userData?.info?.OS)} />
                          </ListItem>
                        </>
                      )}
                    </List>
                  )}
                </AuthUserContext.Consumer>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
};

const ListInfoItem = (props) => {
  const { setUp, data, icon, firebase } = props;
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleOpen = () => {
    setUp.editable && !setUp.isBoolean && setIsModalOpen(true);
  };

  if (setUp.type === "password") {
    return <PasswordItem setUp={setUp} data={data} firebase={firebase} />;
  } else {
    return (
      <>
        <ListItem button style={{ paddingBottom: setUp.value == "" && 24 }} onClick={handleOpen}>
          {!!icon && <ListItemIcon>{setUp.icon}</ListItemIcon>}

          <ListItemText primary={t(setUp.item)} secondary={t(data[setUp.value[0]]?.[setUp.value[1]])} />

          <ListItemSecondaryAction>{setUp.editable && <ArrowForwardIos />}</ListItemSecondaryAction>
        </ListItem>
        <EditableModal open={isModalOpen} onClose={handleClose} auth={data} setUp={setUp} />
      </>
    );
  }
};

const PasswordItem = (props) => {
  const { setUp, data, firebase } = props;
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [error, setError] = useState(null);

  const handleOpen = () => {
    setIsLoading(true);

    !!data.info.email &&
      firebase
        .sendPasswordEmail(data.info.email)
        .then(() => {
          setIsLoading(false);
          setOpenSnackBar(true);
          setError(null);
        })
        .catch((error) => {
          setIsLoading(false);
          setOpenSnackBar(true);
          setError("auth." + error.code);
        });
  };

  return (
    <>
      <Dialog open={openSnackBar}>
        <DialogTitle id="simple-dialog-title">{t("resetPassword")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{!!error ? t(error) : t("checkEmail")}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSnackBar(false)}>{t("aceptar")}</Button>
        </DialogActions>
      </Dialog>

      <ListItem button style={{ paddingBottom: setUp.value == "" && 24 }} onClick={handleOpen}>
        <ListItemText
          primary={setUp.item}
          secondary={
            !!data[setUp.value[0]]?.[setUp.value[1]]
              ? t("last_pasword_modification", { time: moment(data[setUp.value[0]]?.[setUp.value[1]]).format("LL") })
              : t("the_password_has_never_been_changed")
          }
        />
        <ListItemSecondaryAction>{isLoading ? <CircularProgress /> : <ArrowForwardIos />}</ListItemSecondaryAction>
      </ListItem>
    </>
  );
};

const InfoItem = (props) => {
  const classes = useStyles();
  const { setUp, data, isLoading } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleOpen = () => {
    setUp.editable && !setUp.isBoolean && setIsModalOpen(true);
  };

  return (
    <>
      <Grid
        item
        xs={12}
        container
        className={setUp.editable ? classes.item : classes.noEditableItem}
        style={{ padding: !setUp.editable && 24 }}
        onClick={handleOpen}
        alignItems="center"
      >
        <Grid item xs={5} lg={3}>
          {t(setUp.item)}
        </Grid>
        <Grid item xs={5} lg={7}>
          {isLoading ? <Skeleton /> : t(data[setUp.value[0]]?.[setUp.value[1]])}
        </Grid>
        <Grid item xs={2} lg={2} container alignContent="center" justifyContent="flex-end">
          {setUp.editable ? setUp.isBoolean ? <EnableComunicationsEdit auth={data} /> : <ArrowForwardIos /> : <></>}
        </Grid>
      </Grid>
      <EditableModal open={isModalOpen} onClose={handleClose} auth={data} setUp={setUp} />
    </>
  );
};

const EditableModal = (props) => {
  const { open, onClose, setUp, auth } = props;
  const { t } = useTranslation();

  return (
    <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth>
      <DialogTitle>{t(setUp.item)}</DialogTitle>
      {setUp.type == "name" && <NameEdit close={onClose} auth={auth} />}
      {setUp.type == "date" && <BirthDayEdit close={onClose} auth={auth} />}
      {setUp.type == "dni" && <DNIEdit close={onClose} auth={auth} />}
      {setUp.type == "phone" && <PhoneNumberEdit close={onClose} auth={auth} />}
      {setUp.type == "lang" && <LangsEdit close={onClose} auth={auth} param={setUp.param} settings={setUp.value[0]} />}
    </Dialog>
  );
};

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(UserProfile);

const useStyles = makeStyles((theme) => ({
  title: {
    "line-height": "2rem",
    "font-size": " 1.5rem",
    "letter-spacing": " 0",
    "font-weight": " 400",
    hyphens: " auto",
    "word-break": " break-word",
    "word-wrap": " break-word",
    color: " rgb(32,33,36)",
    [theme.breakpoints.up("md")]: {
      "line-height": "2.25rem",
      "font-size": " 1.75rem",
    },
  },
  descriptionTitle: {
    fontSize: "0.875rem",
    "font-weight": " 400",
    "letter-spacing": " 0.01785714em",
    "line-height": " 1.25rem",
    hyphens: " auto",
    "word-break": " break-word",
    "word-wrap": " break-word",
    color: " rgb(95,99,104)",
    "margin-top": " 12px",
  },
  card: {
    borderRadius: 8,
    border: "1px solid rgb(218,220,224)",
    background: "#fff",
    height: "100%",
  },
  item: {
    padding: 24,
    "&:hover": {
      background: grey[100],
      cursor: "pointer",
    },
  },
  noEditableItem: {
    "&:hover": {
      cursor: "inherit",
      background: "inherit",
    },
  },
  CardTitleContainer: {
    padding: 24,
    paddingBottom: 8,
  },
  CardTitle: {
    fontSize: "1.475rem",
  },
  cardDescription: {
    paddingTop: 8,
    fontSize: "1.1rem",
  },
  sectionTitleContainer: {
    marginTop: 32,
    marginBottom: 24,
    paddingLeft: 12,
  },
  description: {
    lineHeight: "1.2rem",
    fontSize: "0.975rem",
  },
}));
